// Hidden materials remain in inventory APIs and in already recorded receipt items.
// A missing flag in an older response preserves the previous product visibility.
export const receiptProducts = products => (products || []).filter(product => product.is_active && !product.hide_from_receipts);
